/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { objectToArray, checkValidity } from "utils";
import Input from "App/common/ui/Input";
import { LayoutContext } from "App/common/hoc/Layout";
import ShowHidePassword from "App/common/ui/ShowHidePassword";
import { cancelAccountStart, cancelAccountResetState } from "store/actions";

function CancelAccount(props) {
  const { lState, lMethods } = useContext(LayoutContext);
  const [form, setForm] = useState({
    0: {
      password: {
        key: "password",
        title: "Password",
        type: "input",
        props: {
          type: "password"
          // placeholder: "Password"
        },
        value: "",
        validation: { required: true, isPassword: true },
        valid: true,
        error: ""
      }
    },
    1: {
      phone: {
        key: "phone",
        title: "Phone Number",
        type: "input",
        props: {
          type: "text"
          // placeholder: "Phone Number"
        },
        value: "",
        validation: { required: true, isPhoneNumber: true },
        valid: true,
        error: ""
      },
      emailid: {
        key: "emailid",
        title: "Email Address",
        type: "input",
        props: {
          type: "text",
          // placeholder: "Email Address",
          disabled: true
        },
        value: "",
        validation: { required: true, isEmail: true },
        valid: true,
        error: ""
      }
    },
    2: {
      reason: {
        key: "reason",
        title: "I am cancelling my IDrive Mirror account because:",
        type: "select",
        class: "input_full_width",
        props: {
          options: [
            "Select a reason",
            "IDrive Mirror has connectivity issues",
            "IDrive Mirror does not have the necessary features",
            "IDrive Mirror has several bugs",
            "IDrive Mirror customer support was not helpful",
            "IDrive Mirror is no longer needed",
            "Others (Use the Comments box below)"
          ]
        },
        value: "",
        validation: { required: true },
        valid: true,
        error: ""
      }
    },
    3: {
      comments: {
        key: "comments",
        title: "Comments",
        type: "textarea",
        class: "input_textarea",
        props: {
          cols: 30,
          rows: 10,
          maxLength: 250
        },
        value: "",
        validation: null,
        valid: true,
        error: ""
      }
    }
  });

  useEffect(() => {
    let details = null;

    if (lState.popup.params.details) details = lState.popup.params.details;
    else {
      details = {};
      details["phone"] = props.userDetails.phone;
      details["emailid"] = props.userDetails.emailid;
    }

    const updatedForm = { ...form };
    for (let key in updatedForm) {
      const row = { ...updatedForm[key] };

      for (let inputKey in row) {
        const input = { ...row[inputKey] };

        if (details[inputKey]) input.value = details[inputKey];

        row[inputKey] = input;
      }

      updatedForm[key] = row;
    }

    setForm(updatedForm);
  }, []);

  useEffect(() => {
    lMethods.updatePopupParams({
      execute: formSubmitHandler
    });
  }, [form]);

  useEffect(() => {
    lMethods.updatePopupParams({
      loading: props.cancelAccount.loading,
      error: props.cancelAccount.error
    });
  }, [props.cancelAccount]);

  function inputChangeHandler(index, key, value) {
    const updatedForm = { ...form };
    const row = { ...updatedForm[index] };
    const updatedInput = { ...row[key] };

    updatedInput.value =
      key === "reason" && value === "Select a reason" ? "" : value;
    row[key] = updatedInput;
    updatedForm[index] = row;

    if (key === "reason") {
      const updatedCommentsInput = { ...updatedForm[3].comments };

      if (value === "Others (Use the Comments box below)") {
        updatedCommentsInput.validation = { required: true };
      } else {
        updatedCommentsInput.validation = null;
        updatedCommentsInput.valid = true;
      }

      updatedForm[3] = { ...updatedForm[3], comments: updatedCommentsInput };
    }

    setForm(updatedForm);
    if (document.activeElement && document.activeElement.tagName === "SELECT") {
      document.activeElement.blur();
    }
  }

  function formSubmitHandler() {
    let isFormValid = true;
    const updatedForm = { ...form };
    const updatedCancelDetails = {};

    for (let key in updatedForm) {
      const updatedRow = { ...updatedForm[key] };
      for (let inputKey in updatedRow) {
        const updatedInput = { ...updatedRow[inputKey] };
        const validationObj = checkValidity(
          updatedInput.value ? updatedInput.value : "",
          updatedInput.validation,
          inputKey
        );
        updatedInput.valid = validationObj.isValid;
        updatedInput.error = validationObj.errMsg;

        if (!updatedInput.valid) isFormValid = false;

        updatedRow[inputKey] = updatedInput;
        updatedCancelDetails[inputKey] = updatedInput.value;
      }
      updatedForm[key] = updatedRow;
    }

    updatedCancelDetails["countryCode"] = props.userDetails.countryCode;

    setForm(updatedForm);

    if (isFormValid) {
      lMethods.openPopup("CancelAccountConfirmation", {
        execute: () => props.cancelAccountStart(updatedCancelDetails)
      });
    }
  }

  return (
    <div className="popup_body_scrollbar">
      <p className="account_delete_description">
        On cancellation, your IDrive Mirror account along with all the data
        stored in it will be permanently deleted.
      </p>
      <p className="user_name">
        User Name:{" "}
        <span className="semi_strong">
          {props.userDetails.firstname + " " + props.userDetails.lastname}
        </span>
      </p>
      {objectToArray(form).map((val, i) => (
        <div key={i} className="input_group">
          {objectToArray(val).map((input, j) => (
            <div
              key={j}
              className={"input_field_msg " + (input.class ? input.class : "")}
            >
              <div>
                <label>{input.title}</label>
                {input.key === "password" ? (
                  <div className="pwd-icon">
                    <Input
                      {...{
                        type: input.type,
                        inputProps: { ...input.props, value: input.value },
                        onChange: e =>
                          inputChangeHandler(i, input.key, e.target.value),
                        autoFocus: true
                      }}
                    />

                    <ShowHidePassword
                      show={input.props.type === "text"}
                      state={form}
                      setState={setForm}
                      path={[i, input.key].join(".")}
                      subProp={"props"}
                    />
                  </div>
                ) : (
                  <Input
                    {...{
                      type: input.type,
                      inputKey: input.key,
                      inputProps: { ...input.props, value: input.value },
                      onChange: e =>
                        inputChangeHandler(i, input.key, e.target.value)
                    }}
                  />
                )}
              </div>
              {!input.valid && (
                <span className="error-msg" style={{ display: "block" }}>
                  {input.error}
                </span>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    userDetails: state.account.userDetails,
    cancelAccount: state.account.cancelAccount
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { cancelAccountStart, cancelAccountResetState },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CancelAccount);
